import { ReactNode } from "react";
import { ThreeDotsLoader } from "../../../../../../../components";
import styles from "./card-subtitle.module.scss";

interface ILoading {
  color?: string;
  text?: ReactNode;
}

const Loading = ({ color, text = "Loading" }: ILoading) => (
  <div
    className={styles.loading}
    data-testid="report_summary_subheader_loading_indicator"
  >
    <span style={{ color }}>{text}</span>
    <ThreeDotsLoader color={color} height={6} />
  </div>
);

export default Loading;
